// 1.异步权限路由
import asyncRoutes from '../asyncRoutes'
// 2.公共权限路由
import commonRoutes from '../commonRoutes'

export const asyncMenus = getItemWithId(asyncRoutes)

export const commonMenus = getItemWithId(commonRoutes)

// 筛选出具有id属性的列表项
function getItemWithId (arr) {
  const filterArr = []
  for (let i = 0; i < arr.length; i++) {
    const item = arr[i]
    const obj = {}
    if (item && item.meta && item.meta.id) {
      Object.keys(item).forEach(o => {
        if (o === 'children') {
          const childList = getItemWithId(item[o])
          if (childList.length) {
            obj.children = childList
          }
        } else if (o !== 'component') {
          obj[o] = item[o]
        }
      })
      filterArr.push(obj)
    }
  }
  return filterArr
}
